import Breadcrumb from "components/Breadcrumb/Breadcrumb"
import SwitchOptionTable from "components/OptionsTable/SwitchOptionTable"
import NewStaticTable from "components/staticTable/NewStaticTable"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getDay } from "tools/functions/Methods"
// import ShiftAllocate from "../../../assets/icons/shiftAllocate.svg"
import { AiOutlineEdit } from "react-icons/ai"
import { useNavigate } from "react-router-dom"
import { clearConsignment, clearConsignments } from "redux/OrderData/OrderData"
import { addOrderData, clearEasyOrderData } from "redux/order-management-new"
import { InternalOrderColumn } from "./Columns"
import FishSearchForm from "./Search"
import { useGetInternalOrderConsignments } from "./utils"
import DeleteOperation from "components/tableOperation/DeleteOperation"
import { filterOrderInternal } from "redux/order-internal"
import { paginationType } from "global/Interfaces/Interfaces"
import { GiConfirmed } from "react-icons/gi"
import TooltipWrapper from "global/tooltip/TooltipWrapper"
import { Confirm } from "pages/optimePanel/components/confirm-modal"
import { addEditDataAPI } from "services/CRUDServices"
import { BiShow } from "react-icons/bi"
import { hasPermission } from "utils/HasPermission"

const InternalOrderManagemnt = () => {
  const dispatch = useDispatch()
  const [openConfirm, setOpenConfirm] = useState(false)
  const [orderId, setOrderId] = useState("")
  const [finalizeLoading, setFinilizeLoading] = useState(false)
  const { getInternalOrderConsignments } = useGetInternalOrderConsignments()
  const { orderInternalLists, fetchpost, filter } = useSelector(
    (state: any) => state.OrderInternalSlice
  )
  const { pageNumbers } = useSelector((state: paginationType) => state.paginate)
  const navigate = useNavigate()

  const refreshTable = () => {
    dispatch(
      filterOrderInternal({
        ...filter,
        pageSize: 10,
        pageNumber: pageNumbers,
      }) as any
    )
  }
  let data =
    orderInternalLists?.content?.length !== 0
      ? orderInternalLists?.content?.map((item: any) => {
          return {
            ...item,
            senderHub: item.senderHub?.text,
            creationDate: getDay(item.creationDate),
            status: item.status?.text,

            operation: (
              <div className="flex w-full gap-3 justify-center">
                {hasPermission("edit_inner_order") && (
                  <button
                    className=" border-none	text-[14px]  w-[20px] h-[20px] "
                    onClick={async () => {
                      await getInternalOrderConsignments(item.orderId)
                      dispatch(
                        addOrderData({
                          orderId: item.orderId,
                          senderHub: item.senderHub,
                          receiverHub: item.receiverHub,
                          openModal: false,
                          status: item.status,
                        })
                      )
                      navigate("/add-internal-order")
                    }}
                  >
                    {item.status?.id === 1 ? (
                      <BiShow className="w-[20px] h-[20px]" size={15} />
                    ) : (
                      <AiOutlineEdit className="w-[20px] h-[20px]" size={15} />
                    )}
                  </button>
                )}

                {hasPermission("confirm_inner_order") && item.status?.id !== 1 && (
                  <button
                    disabled={finalizeLoading}
                    className=" border-none	text-[14px]  "
                    onClick={async () => {
                      setOrderId(item.orderId)
                      setOpenConfirm(true)
                    }}
                  >
                    <TooltipWrapper textProps={"نهایی سازی سفارش"}>
                      <GiConfirmed className="w-[18px] h-[18px]" size={12} />
                    </TooltipWrapper>
                  </button>
                )}
                {hasPermission("delete_inner_order") && item.status?.id !== 1 && (
                  <DeleteOperation
                    itemId={item.orderId}
                    title={"حذف سفارش"}
                    handleDeleteActionNewData={refreshTable}
                    route={
                      "/consignment-api/internalConsignmentWizard/deleteOrder"
                    }
                  />
                )}
              </div>
            ),
          }
        })
      : []

  const finalize = async () => {
    try {
      setFinilizeLoading(true)
      await addEditDataAPI(
        `/consignment-api/internalConsignmentWizard/finalizeOrder/${orderId}`,
        "post",
        {}
      )
      refreshTable()
      setFinilizeLoading(false)
      setOpenConfirm(false)
    } catch {
      setFinilizeLoading(false)
    }
  }

  useEffect(() => {
    dispatch(clearConsignment())
    dispatch(clearConsignments())
    dispatch(clearEasyOrderData(null))
    return () => {}
  }, [dispatch])

  return (
    <>
      <Breadcrumb curentPage="مدیریت سفارش های داخلی" beforePage="" />

      <FishSearchForm />
      <SwitchOptionTable
        accessPage={[
          {
            code: "A24",
            value: () => navigate("/add-internal-order"),
            permission: "create_inner_order",
          },
          {
            code: "A1",
            value: {
              data: data,
              columns: InternalOrderColumn,
              title: "orderInternalLists",
            },
          },
        ]}
        // selectedState={selectedRow}
      />
      <NewStaticTable
        data={data ? data : []}
        THWrapper={"whitespace-nowrap"}
        pagination={orderInternalLists?.totalElements}
        column={InternalOrderColumn}
        loading={fetchpost}
        ignoreRedux={true}
      />
      <Confirm
        open={openConfirm}
        setOpen={setOpenConfirm}
        title="آیا از انجام این کار مطمئن هستید؟"
        handleClick={finalize}
        loading={finalizeLoading}
      ></Confirm>
    </>
  )
}

export default InternalOrderManagemnt
